var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ebebeb",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c9cbcb",
    d: "M95.35,29.37H31.65c-4.43,0-8.04,3.6-8.04,8.04v43.13c0,4.43,3.6,8.04,8.04,8.04h19.55l-1.79,5.25h-3.08c-1.66,0-3.01,1.35-3.01,3.01s1.35,3.01,3.01,3.01h34.37c1.66,0,3.01-1.35,3.01-3.01s-1.35-3.01-3.01-3.01h-3.08l-1.79-5.25h19.55c4.43,0,8.04-3.6,8.04-8.04v-43.13c0-4.43-3.6-8.04-8.04-8.04ZM55.77,93.82l1.79-5.25h11.88l1.79,5.25h-15.46ZM97.36,77.79v2.74c0,1.11-.9,2.01-2.01,2.01H31.65c-1.11,0-2.01-.9-2.01-2.01v-2.74h67.73ZM31.65,35.4h63.71c1.11,0,2.01.9,2.01,2.01v34.36H29.63v-34.36c0-1.11.9-2.01,2.01-2.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallUnavailable);
export default __webpack_public_path__ + "static/media/video-call-unavailable.b4125867b3b7e65ae9da1fe00790d0b6.svg";
export { ForwardRef as ReactComponent };